import { render, staticRenderFns } from "./add-ad-neg-target.vue?vue&type=template&id=1ff7ac40&scoped=true&"
import script from "./add-ad-neg-target.vue?vue&type=script&lang=js&"
export * from "./add-ad-neg-target.vue?vue&type=script&lang=js&"
import style0 from "./add-ad-neg-target.vue?vue&type=style&index=0&id=1ff7ac40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff7ac40",
  null
  
)

export default component.exports